export default "__VITE_ASSET__27a769b2__"